// Palworld OFFICIAL CARD GAME — "Sleeve & Card Set Vol.1" (SS01).
//
// Every value below is transcribed from the official Japanese product reveal
// images published on palworld-official-cardgame.com (product page /products/ss01
// and its English mirror). Card text is translated from the printed Japanese
// wording; the English printing of this set has not been published yet, so the
// codes here are the printed Japanese codes (SS01-001 … SS01-005) and the
// English names are the official English Pal names for each Pal.
//
// Card images © Pocketpair, Inc. / Bushiroad, shown for identification.
import n1 from "@/assets/ss01/card-n1.webp.asset.json";
import n2 from "@/assets/ss01/card-n2.webp.asset.json";
import n3 from "@/assets/ss01/card-n3.webp.asset.json";
import n4 from "@/assets/ss01/card-n4.webp.asset.json";
import n5 from "@/assets/ss01/card-n5.webp.asset.json";
import p1 from "@/assets/ss01/card-p1.webp.asset.json";
import p2 from "@/assets/ss01/card-p2.webp.asset.json";
import p3 from "@/assets/ss01/card-p3.webp.asset.json";
import p4 from "@/assets/ss01/card-p4.webp.asset.json";
import p5 from "@/assets/ss01/card-p5.webp.asset.json";
import slide from "@/assets/ss01/slide.webp.asset.json";

export interface Ss01Card {
  code: string;
  pal: string;
  nameJa: string;
  nameEn: string;
  rarity: string;
  color: string;
  cost: number;
  power: number;
  strike: number;
  type: string;
  work: string[];
  effect: string;
  flavor: string;
  /** Base (non-parallel) card scan. */
  image: string;
  /** Parallel (foil) version of the same card. */
  parallel: string;
}

export const SS01_RELEASE = "October 16, 2026";
export const SS01_MSRP_JPY = 4400;
export const SS01_SLEEVE_COUNT = 75;
export const SS01_KEY_VISUAL = slide.url;

export const SS01_CARDS: Ss01Card[] = [
  {
    code: "SS01-001",
    pal: "Grizzbolt",
    nameJa: "降り注ぐ電撃 - エレパンダ",
    nameEn: "Raining Lightning – Grizzbolt",
    rarity: "R",
    color: "Red",
    cost: 6,
    power: 1000,
    strike: 2,
    type: "Normal Pal",
    work: ["Electricity", "Crafting", "Collecting", "Transporting"],
    effect: "AUTO [On Deploy] Choose all of your opponent's Pals and deal 300 damage to each of them.",
    flavor: "Bolts crashing down leave the whole area numb.",
    image: n5.url,
    parallel: p5.url,
  },
  {
    code: "SS01-002",
    pal: "Chillet",
    nameJa: "仕上げの氷刃 - オコチョ",
    nameEn: "Finishing Ice Blade – Chillet",
    rarity: "R",
    color: "Blue",
    cost: 6,
    power: 1000,
    strike: 2,
    type: "Normal Pal",
    work: ["Harvesting", "Cooling"],
    effect: "AUTO When the Pal this card battled is placed in the graveyard, draw 1 card.",
    flavor: "Chillet going all out is faintly chilly — and thrilling.",
    image: n3.url,
    parallel: p3.url,
  },
  {
    code: "SS01-003",
    pal: "Depresso",
    nameJa: "深夜の本気 - ンダコアラ",
    nameEn: "Midnight Effort – Depresso",
    rarity: "R",
    color: "Purple",
    cost: 3,
    power: 300,
    strike: 1,
    type: "Normal Pal",
    work: ["Crafting", "Collecting", "Transporting", "Farming"],
    effect:
      "CONT Nocturnal (during Night, this card gets Power +300). AUTO [On Deploy] During Night, choose up to 1 Structure; until end of turn it gets Durability -500 (it is not placed in the graveyard even if Durability drops to 0 or less).",
    flavor: "Even a proud pillar — gone in a single night.",
    image: n2.url,
    parallel: p2.url,
  },
  {
    code: "SS01-004",
    pal: "Cattiva",
    nameJa: "自信満々 - ツッパニャン",
    nameEn: "Full of Confidence – Cattiva",
    rarity: "R",
    color: "Colorless",
    cost: 3,
    power: 300,
    strike: 1,
    type: "Normal Pal",
    work: ["Harvesting", "Crafting", "Collecting", "Transporting"],
    effect:
      "CONT If you have 5 or more Souls, this card gets Power +200. CONT If you have 10 or more Souls, this card gets a further Power +200.",
    flavor: "The more confidence swells, the hotter those paw pads burn.",
    image: n1.url,
    parallel: p1.url,
  },
  {
    code: "SS01-005",
    pal: "Quivern",
    nameJa: "翼竜の息吹 - フェスキー",
    nameEn: "Wyvern's Breath – Quivern",
    rarity: "R",
    color: "Colorless",
    cost: 6,
    power: 1300,
    strike: 2,
    type: "Lucky Pal",
    work: ["Harvesting", "Crafting", "Collecting", "Transporting"],
    effect:
      "AUTO When this card attacks a Pal or a Structure, choose up to 1 Pal or Structure and deal 700 damage to it.",
    flavor: "Devastating power you would never guess from that adorable shape.",
    image: n4.url,
    parallel: p4.url,
  },
];
